import AppNavigation from '@layouts/dashboard/components/navigation/app-navigation'
import SettingsIcon from '@assets/images/settings-icon.svg?react'

import './header.scss'
import { SimpleMenu } from '@/ui/components/SimpleMenu'
import { useHeader } from './hooks/useHeader'
import { useBreakpoints } from '@/core/hooks/useBreakpoints/useBreakpoints'
import AccountPicker from '@/ui/components/account-picker'
import StanceLogo from '../sidebar/components/StanceLogo/StanceLogo'
import { useCustomTheme } from '@/core/theme'
import { useRouting } from '@/core/hooks/useRouting'
import ArrowLeftIcon from '@assets/images/arrow-left.svg?react'
import { AccountModule } from '@/core/modules/account/account.module'

interface Props {
    error?: boolean
    showAppNavigation?: boolean
}

const Header = ({ error, showAppNavigation = true }: Props) => {
    const { items, open, setOpen, handleLogoClick, handleBackToMdrClick } =
        useHeader()
    const { shouldHideSidebar, location, ROUTES } = useRouting()
    const { aboveBreakpoint, belowBreakpoint } = useBreakpoints()
    const { accountType } = AccountModule.useStore()
    const isSettingsPage = location?.pathname?.includes(ROUTES.settings.path)
    const showBackButton =
        belowBreakpoint('xl') && isSettingsPage && accountType === 'MDR'
    const theme = useCustomTheme()

    return (
        <header className="header">
            <div className="header-content-wrapper">
                <div className="header-left">
                    {showBackButton && (
                        <ArrowLeftIcon
                            className="back-button"
                            onClick={handleBackToMdrClick}
                        />
                    )}
                    <div className="app-navigation">
                        {!error &&
                            showAppNavigation &&
                            belowBreakpoint('xl') && <AppNavigation />}
                    </div>

                    {shouldHideSidebar && aboveBreakpoint('xl') && (
                        <div className="icon-container">
                            <StanceLogo
                                iconGap={9}
                                onClick={handleLogoClick}
                                iconColor={theme.colors.greys[900]}
                                textColor={theme.colors.greys[900]}
                            />
                        </div>
                    )}
                    <AccountPicker />
                </div>
                <SimpleMenu
                    onActivate={() => setOpen(!open)}
                    open={open}
                    onClose={() => setOpen(false)}
                    activator={<SettingsIcon height={22} width={22} />}
                    openLeft={true}
                    dataTestId="settings-menu"
                    items={items}
                    menuPosition="fixed"
                />
            </div>
        </header>
    )
}
export default Header
